import React, { useCallback } from "react";
import {useDispatch, useSelector} from "react-redux";
import { hideMenuAlert } from '../store/actions/menu.actions';
import { Modal } from './Modal';

function MenuAlert() {
    const dispatch = useDispatch();

    const alert = useSelector(state => state.menu.alert);

    const handleCloseAlert = useCallback((e) => {
        dispatch(hideMenuAlert());
    }, [dispatch]);
    
    return (
        <Modal title="Attention!" onClose={handleCloseAlert} isOpen={alert.isShow}>
            {alert?.body}
        </Modal>
    )
}

export default MenuAlert;